import { request } from "../http";

export default {
    // 获取案例类型
    getCaseTypeList(params) {
        return request('post', '/sd_smi/api/v1/H5_Case/getCaseTypeList', params, 'json');
    },

    // 获取案例属性
    getCaseAttrList(params) {
        return request('get', '/sd_smi/api/v1/H5_Case/getCaseAttrList', params, 'json');
    },

    // 获取案例列表
    getCaseList(params) {
        return request('post', '/sd_smi/api/v1/H5_Case/getCaseList', params, 'json');
    },
    
    // 获取案例详情
    getCaseDetail(params) {
        return request('post', '/sd_smi/api/v1/H5_Case/getCaseDetail', params, 'json');
    },
    
    // 案例收藏
    caseFav(params) {
        return request('post', '/sd_smi/api/v1/H5_Case/caseFav', params, 'json', {checkLogin: true, useParams: true});
    },
    
    // 获取案例收藏列表
    getCaseFavList(params) {
        return request('post', '/sd_smi/api/v1/H5_Case/getCaseFavList', params, 'json');
    },
    
    // 获取案例主题列表
    getCaseSubjectList(params) {
        return request('post', '/sd_smi/api/v1/H5_Case/getCaseSubjectList', params, 'json');
    },
    
    // 获取案例主题详情
    getCaseSubjectDetail(params) {
        return request('post', `/sd_smi/api/v1/H5_Case/getCaseSubjectDetail?caseSubjectId=${params.caseSubjectId}`, params, 'json');
    },

    // 获取租户区域列表
    getSubLevelList(params) {
        return request('post', `/sd_smi/api/v1/Web_User/getSubLevelList`, params, 'json', {useParams: true});
    },
    
}


// WEBPACK FOOTER //
// ./src/request/apis/case.js